import {
  BackendResponseFM,
  MedicalFlag,
  MedicalFlagLabel,
  PerimenopauseAssessment,
  PerimenopauseStage,
} from '@naturalcycles/shared'
import { Action, Reducer } from 'redux'

type State = PerimenopauseAssessment | null

const initialState: State = null

const actions: any = {
  onBackendResponse(state: State, action: { type: string; payload: BackendResponseFM }): State {
    if (action.payload.perimenopauseAssessment === null) return null
    return action.payload.perimenopauseAssessment || state
  },

  setPerimenopauseAssessmentState(
    state: PerimenopauseAssessment,
    action: { type: string; payload: PerimenopauseStage },
  ): State {
    return {
      ...state,
      stage: action.payload,
    }
  },

  setPerimenopauseAssessmentFlags(
    state: PerimenopauseAssessment,
    action: { type: string; payload: Partial<Record<MedicalFlag, MedicalFlagLabel>> },
  ): State {
    return {
      ...state,
      flags: action.payload,
    }
  },
}

export const perimenopauseAssessmentReducer: Reducer<State> = (
  // biome-ignore lint/style/useDefaultParameterLast: ok
  state = initialState,
  action: Action,
) => {
  if (actions[action.type]) return actions[action.type](state, action)
  return state
}
